module.exports = __webpack_public_path__ + "img/Drums.35fc4a87.png";